import Papa from "papaparse"

/**
 * Validates if CSV headers match the expected headers
 *
 * @param {File} file - The CSV file to validate
 * @returns {Promise} - Resolves with {isValid: boolean}
 */
export const validateCsvHeaders = (file) => {
	return new Promise((resolve, reject) => {
		const expectedHeaders = [
			"Address",
			"City",
			"State",
			"Zip",
			"Work Order Contact Email",
			"Is Deal Under Contract",
			"Inspection Period Date",
			"Closing Date",
			"Is Electric On?",
			"Is Water On?",
			"Is Gas On?",
			"Is Property Occupied?",
			"Current Resident Name",
			"Current Resident Email",
			"Current Resident Phone Number",
			"Lock Code Combo",
			"Lock Code Location",
			"Key Code",
			"Gate Code",
			"Service Type",
			"Preferred Service Dates",
			"Job Request Details",
		]

		Papa.parse(file, {
			header: true,
			skipEmptyLines: true,
			complete: (results) => {
				if (results.errors.length > 0) {
					console.error("CSV parsing errors:", results.errors)
					resolve(false)
					return
				}

				const headers = results.meta.fields || []

				// Check if all expected headers are present
				const missingHeaders = expectedHeaders.filter(
					(header) => !headers.includes(header)
				)

				// Check if there are any extra headers
				const extraHeaders = headers.filter(
					(header) => !expectedHeaders.includes(header)
				)

				const isValid = missingHeaders.length === 0 && extraHeaders.length === 0
				resolve(isValid)
			},
			error: (error) => {
				resolve(false)
			},
		})
	})
}
